import { useState, useEffect } from "react";
import DocsTable from "./DocsTable";
import Cookies from "js-cookie";
import { getModel } from "../../../../API/ModelList";
import { useNavigate } from "react-router-dom";

const DocsConfiguration = () => {
  const [configKey, setConfigKey] = useState(null);
  const navigate = useNavigate();
  const configkeyset = Cookies.get("configkey");

  const autoSelectElement = async () => {
    const idToken = Cookies.get("Token");
    try {
      const modelData = await getModel(idToken);

      if (modelData.length === 1) {
        const model = modelData[0];
        const modelComponent = model.ModelComponent;

        if (!modelComponent) {
          setConfigKey("DefaultDocs");
          Cookies.set("configkey", "DefaultDocs");
          navigate(`/User/DefaultDocs`);
          return;
        }

        const newConfigKey =
          modelComponent.charAt(0).toUpperCase() +
          modelComponent.slice(1) +
          "Docs";

          console.log("newConfigKey :", newConfigKey);

        setConfigKey(newConfigKey);
        Cookies.set("configkey", newConfigKey);
        navigate(`/User/${newConfigKey}`);
      } else {
        setConfigKey("DefaultDocs");
        Cookies.set("configkey", "DefaultDocs");
        navigate(`/User/DefaultDocs`);
      }
    } catch (error) {
      console.error("Erreur dans autoSelectElement :", error);
      setConfigKey("DefaultDocs");
      Cookies.set("configkey", "DefaultDocs");
      navigate(`/User/DefaultDocs`);
    }
  };

  useEffect(() => {
    if (!configkeyset) {
      autoSelectElement();
    } else {
      setConfigKey(configkeyset);
    }
  }, []);

  if (!configKey) return <div>Chargement...</div>;

  return <DocsTable configKey={configKey} />;
};

export default DocsConfiguration;
